import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetGroupQuery } from '@/services/sibling-group-api';
import Page from '@/components/page';
import PageTitle from '@/components/page-title';
import EditForm from './edit-form';

const EditSiblingGroup = ({ triggerUpdate }) => {
  const navigate = useNavigate();
  const { groupId } = useParams();
  const { data, isLoading } = useGetGroupQuery({ groupId }, { skip: !groupId });

  useEffect(() => {
    if (groupId && !isLoading && !data) {
      navigate('/sibling-group');
    }
  }, [groupId, data, isLoading, navigate]);

  const title = groupId ? 'Edit' : 'New';

  return (
    <Page
      breadcrumb={[
        { path: '/sibling-group', label: 'Sibling Group' },
        groupId && { path: `/sibling-group/${groupId}`, label: groupId },
        title,
      ]}
      size="xl"
      loading={groupId && !data}
    >
      <PageTitle label={`${title} Sibling Group`} />
      <EditForm groupData={data} triggerUpdate={triggerUpdate} />
    </Page>
  );
};

export default EditSiblingGroup;
